import { useTranslation } from 'next-i18next';
import React, { useMemo } from 'react';
import CategoryList from 'src/features/common/collectible/components/category-list';
import { StyledDescription } from 'src/features/common/collectible/containers/nft-about-info-container/styles';
import { useCollectible } from 'src/features/common/collectible/hooks/collectible.hooks';
import { descriptionAttributes, descriptionTags, InnerHtml } from 'src/ui/common/atoms/inner-html';
import { CardBox } from 'src/ui/common/layouts/card-box';

export const NftAboutInfoContainer = () => {
    const nft = useCollectible();
    const { t } = useTranslation(['pages']);

    const locale = useMemo(
        () => ({
            title: t('nft.view.about.title'),
        }),
        [t]
    );

    if (!nft) {
        return null;
    }

    return (
        <CardBox allowCollapse>
            <CardBox.Heading>{locale.title}</CardBox.Heading>
            <CardBox.Content>
                <StyledDescription>
                    <InnerHtml
                        value={nft.description}
                        allowedTags={descriptionTags}
                        allowedAttributes={descriptionAttributes}
                    />
                </StyledDescription>
                {nft.subcategoryIds && <CategoryList subcategoryIds={nft.subcategoryIds} />}
            </CardBox.Content>
        </CardBox>
    );
};